module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row wrapper"
  }, [_c('div', {
    staticClass: "col-xl-2 col-lg-12"
  }, [_c('div', {
    staticClass: "markets-amount"
  }, [_vm._v(_vm._s(_vm.forecastWindows.length) + " Markets")]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('div', {
    staticClass: "roundedNumber",
    style: ({
      backgroundColor: _vm.FORECAST_WINDOW_COLORS.VALIDATED
    })
  }, [_vm._v("\n                " + _vm._s(_vm.forecastWindows.reduce(function (prev, curr) {
    return curr.isValidated ? prev + 1 : prev;
  }, 0)) + "\n            ")]), _vm._v(" "), _c('div', [_vm._v("validated")])]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('div', {
    staticClass: "roundedNumber",
    style: ({
      backgroundColor: _vm.FORECAST_WINDOW_COLORS.SUBMITTED
    })
  }, [_vm._v("\n                " + _vm._s(_vm.forecastWindows.filter(function (fw) { return fw.status === _vm.FORECAST_WINDOW_STATUS.SUBMITTED; }).length) + "\n            ")]), _vm._v("\n            " + _vm._s(_vm.statusNameWindow(_vm.FORECAST_WINDOW_STATUS.SUBMITTED)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('div', {
    staticClass: "roundedNumber",
    style: ({
      backgroundColor: _vm.FORECAST_WINDOW_COLORS.RE_CHALLENGED
    })
  }, [_vm._v("\n                " + _vm._s(_vm.forecastWindows.filter(function (fw) { return fw.status === _vm.FORECAST_WINDOW_STATUS.RE_CHALLENGED; }).length) + "\n            ")]), _vm._v("\n            " + _vm._s(_vm.statusNameWindow(_vm.FORECAST_WINDOW_STATUS.RE_CHALLENGED)) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.forecastWindows), function(forecastWindow) {
    return _c('div', {
      key: forecastWindow.id,
      staticClass: "col-xl-auto col-lg-12 px-4 zone"
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "border-bottom": "1px dotted black",
        "padding-bottom": "1px",
        "width": "100%"
      }
    }, [_c('DefaultButton', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.right",
        value: (_vm.statusName(forecastWindow.forecast.status).toUpperCase()),
        expression: "statusName(forecastWindow.forecast.status).toUpperCase()",
        modifiers: {
          "hover": true,
          "right": true
        }
      }],
      style: ({
        backgroundColor: _vm.statusColor(forecastWindow.forecast.status),
        color: '#000000',
        fontWeight: 'bold'
      }),
      attrs: {
        "disabled": !_vm.forecastWindowAccessible,
        "size": 'xs'
      },
      on: {
        "click": function($event) {
          _vm.$router.push(((_vm.ROUTES.BASE) + "/window/" + (forecastWindow.id)))
        }
      }
    }, [_c('span', [_vm._v("View")]), _vm._v(" "), _c('span', {
      staticClass: "statusBadge"
    }, [_vm._v(_vm._s(_vm.statusLetter(forecastWindow.forecast.status)))])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center",
      staticStyle: {
        "min-width": "180px"
      }
    }, [_c('p', {
      staticClass: "multiValidation my-0 d-inline-block",
      class: {
        hidden: !forecastWindow.multiValidation
      }
    }, [_c('MarketIcon')], 1), _vm._v(" "), _c('p', {
      staticClass: "m-0 mx-2 d-inline-block"
    }, [(forecastWindow.zone.name.length < 16) ? _c('span', [_vm._v(_vm._s(forecastWindow.zone.name))]) : _c('span', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: (forecastWindow.zone.name),
        expression: "forecastWindow.zone.name",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }]
    }, [_vm._v(_vm._s(_vm.formatZoneName(forecastWindow.zone.name)))])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "44px"
      }
    }, [(forecastWindow.status === _vm.FORECAST_WINDOW_STATUS.SUBMITTED) ? _c('div', {
      staticClass: "roundedNumber",
      style: ({
        backgroundColor: _vm.FORECAST_WINDOW_COLORS.SUBMITTED
      })
    }, [_c('SubmittedIcon', {
      staticClass: "icon"
    })], 1) : _vm._e(), _vm._v(" "), (forecastWindow.isValidated) ? _c('div', {
      staticClass: "roundedNumber"
    }, [_c('CheckMarkIcon', {
      staticClass: "icon"
    })], 1) : _vm._e(), _vm._v(" "), (_vm.forecastWindowsIsRechallenged(forecastWindow)) ? _c('div', {
      staticClass: "roundedNumber",
      style: ({
        backgroundColor: _vm.FORECAST_WINDOW_COLORS.RE_CHALLENGED
      })
    }, [_c('ReChallengeIcon', {
      staticClass: "icon"
    })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-grow": "1",
        "align-items": "center",
        "text-align": "right",
        "width": "60px",
        "min-width": "60px"
      }
    }, [(_vm.isDisabledZone(forecastWindow.zone.id)) ? _c('p', {
      staticClass: "text-right w-100 m-0 small"
    }, [_c('i', {
      staticStyle: {
        "font-size": "12px !important"
      }
    }, [_vm._v("(DELETED)")])]) : _vm._e()])], 1)])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d8d9923","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/sections/ZonesDetail.vue
// module id = 3059
// module chunks = 0